import { formatDate } from '@angular/common';

export function format(date: Date, format = `MMM d, y аt h:mm:ss a UTC`, timezone = 'Z'): string {
  return formatDate(date, format, 'en-EN', timezone);
}
